import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

export default createReducer(false, {

    [actions.START_EXPORTING]: (state, action) => true,

    [actions.DONE_EXPORTING]: (state, action) => false

})



// WEBPACK FOOTER //
// ./src/reducers/isExporting.js